import fetchData from "../utils/HttpClient";
import {ApiTopCategoriesResponseInterface} from "../interfaces/core/ApiTopCategoriesResponseInterface";
import {ApiResponseInterface as CatalogApiResponseInterface} from "../interfaces/catalog/ApiResponseInterface";
import {ApiResponseInterface as ProductApiResponseInterface} from "../interfaces/product/ApiResponseInterface";
import {ApiRequestInterface} from "../interfaces/catalog/ApiRequestInterface";
import {SearchResponseItemInterface} from "../interfaces/catalog/SearchRespponseItemInterface";
import {CustomerInterface} from "../interfaces/customer/CustomerInterface";
import {CustomerManagerInterface} from "../interfaces/customer/CustomerManagerInterface";
import {ProductInterface} from "../interfaces/catalog/ProductInterface";

export function getProductsByCategory(categoryId: string, customer: CustomerInterface|CustomerManagerInterface|null = null): Promise<CatalogApiResponseInterface > {
    return fetchData('/api/list/' + categoryId, null, 'GET', customer)
}

export function getProduct(productId: string, customer: CustomerInterface|CustomerManagerInterface|null = null): Promise<ProductApiResponseInterface > {
    return fetchData('/api/item/' + productId, null, 'GET', customer)
}
export function getProductByCode(productCode: string): Promise<ProductInterface > {
    return fetchData('/api/item-by-code/' + productCode, null, 'GET')
}

export function getProducts(params: ApiRequestInterface, customer: CustomerInterface|CustomerManagerInterface|null = null): Promise<CatalogApiResponseInterface > {
    return fetchData('/api/list-by-params', params, 'POST', customer)
}

export function getTopCategories(): Promise<ApiTopCategoriesResponseInterface > {
    return fetchData('/api/top', null, 'GET')
}
export function quickSearch(searchString: string): Promise<SearchResponseItemInterface[] > {
    return fetchData('/api/quick-search', {query: searchString, max_result_count: 100}, 'POST')
}

export function search(searchString: string, customer: CustomerInterface|CustomerManagerInterface|null = null): Promise<CatalogApiResponseInterface> {
    return fetchData('/api/search?search_string=' + searchString, null, 'GET', customer)
}

export function getProductsByCodeCollection(codes: string[], customer: CustomerInterface|CustomerManagerInterface|null = null): Promise<{ products: ProductInterface[] }> {
    return fetchData('/api/code-collection', { codes }, 'POST', customer)
}

export function getProductsByCodePrefix(codePrefix: string, customer: CustomerInterface|CustomerManagerInterface|null = null): Promise<CatalogApiResponseInterface> {
    return fetchData('/api/list-by-codes/' + codePrefix, null, 'GET', customer)
}
